// Controls inside the shared calculator form card on /lal-kitab-kundli and
// /hi/lal-kitab-kundli: submit and the calculation error. Hindi is Devanagari
// (owner decision 2026-10-28, replacing the 2026-10-08 Hinglish rule), like the
// card's labels in BirthDetailsForm.i18n.ts; tests/hindi-register.test.ts
// guards the hi block (Devanagari) and the en block (no Devanagari). The card's
// heading is indexed page copy, Devanagari on /hi/ (owner, 2026-10-08), in
// ./_form-heading.ts; the page's hero, result and offer copy stay with the
// page.
export const LAL_KITAB_CARD_COPY = {
  en: {
    submit: "Get My Lal Kitab Kundli",
    calculationError: "Something went wrong. Please try again.",
  },
  hi: {
    submit: "मेरी लाल किताब कुंडली बनाएँ",
    calculationError: "गणना नहीं हो पाई — कृपया दोबारा कोशिश करें।",
  },
} as const;
